import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  GestoresResiduosControllerService,
  AdheridosPrevisionResiduosControllerService,
  AdheridoEstadoControllerService
} from 'api-rest';
import { SpinnerService } from '../../../services/spinner.service';
import { SnackbarService } from '../../../services/snackbar.service';
import Swal from 'sweetalert2';
import { ValidateService } from '../../../services/validate.service';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';
import { Adherido } from '../../../models/adherido';
import { catchError, map, of, zip } from 'rxjs';
import { UploadWasteForecastComponent } from '../upload-waste-forecast/upload-waste-forecast.component';
import { WasteForecastAddDialogComponent } from '../waste-forecast-add-dialog/waste-forecast-add-dialog.component';
import { WasteForecastDuplicateDialogComponent } from '../waste-forecast-duplicate-dialog/waste-forecast-duplicate-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DownloadService } from '../../../services/download.service';

@Component({
  selector: 'lib-waste-forecast',
  templateUrl: './waste-forecast.component.html',
  styleUrls: ['./waste-forecast.component.scss'],
})
export class WasteForecastComponent implements OnChanges, OnInit {
  @Input() adheridoInfo!: Adherido;
  @Output() public refrescarAdheridoEvent = new EventEmitter<any>();

  formGroup!: FormGroup;
  tiposCodigosLer: any[] = [];
  operacionesGestion: any[] = [];
  suministraInfoList = [
    { id: 'Gestor', name: 'Gestor' },
    { id: 'Adherido', name: 'Adherido' },
  ];
  anios: any[] = [];
  codigosLerEndpoint =
    this.environment.urlBackCore + 'api/v1/core/codigo-ler/filtro-combo?sddrCC=true';
  updateList: boolean = false;
  updateListOpera: boolean = false;
  flagDisabledForm: boolean = false;
  anioActual!: number;
  grid: any[] = [];

  pageNumber: number = 0;
  pageSize: number = 100;
  recordsTotal: number = 0;
  gestionArray: any[] = [];

  headArray: any[] = [
    {
      Head: 'Año',
      FieldName: 'anioDatos',
    },
    {
      Head: 'Código LER y descripción de ENVALORA',
      FieldName: 'descripcionMCodLer',
      width: 60,
      Tooltip: true,
      Maxtext: 9999,
    },
    {
      Head: '',
      FieldName: 'actions',
      buttons: [
        {
          nameButton: 'warning',
          icon: 'warning',
          toolTip:
            'NIMA de gestor no existe en la base de datos de gestores de ENVALORA',
          show: (row: any) => this.showWarning(row),
        },
      ],
    },
    {
      Head: 'NIMA del gestor',
      FieldName: 'nimaGestor',
    },
    {
      Head: '¿Quién suministra información de gestión?',
      FieldName: 'suministradorInformacion',
    },
    {
      Head: 'Acciones',
      FieldName: 'actions',
      buttons: [
        {
          nameButton: 'delete',
          icon: 'delete',
          toolTip: 'Borrar',
          show: { params: 'canAccessDelete', accion: 'delete' },
        },
        {
          nameButton: 'edit',
          icon: 'edit',
          toolTip: 'Editar',
          show: (row: any) => row.canAccessEdit,
        },
        {
          nameButton: 'duplicate',
          icon: 'file_copy',
          toolTip: 'Duplicar',
          show: (row: any) => row.canAccessDuplicate,
        },
      ],
      width: '2',
      permanent: true,
    },
  ];
  mostrarImportar: boolean = false;
  exporting: boolean = false;
  constructor(
    private formBuilder: FormBuilder,
    @Inject('environment') private environment: any,
    public spinnerSrv: SpinnerService,
    private snackBarSrv: SnackbarService,
    private validateSrv: ValidateService,
    private gestoresResiduosControllerService: GestoresResiduosControllerService,
    @Inject('EmpusaAuthenticationService')
    public authService: EmpusaAuthenticationService | any,
    private adheridosPrevisionResiduosControllerService: AdheridosPrevisionResiduosControllerService,
    public dialog: MatDialog,
    private adheridoEstadoService: AdheridoEstadoControllerService,
    private downloadService: DownloadService,
  ) {
    this.formGroup = this.formBuilder.group({
      anio: [{ value: null, disabled: false }],
      codigoLer: [{ value: null, disabled: false }],
      nima: [
        { value: null, disabled: false },
        {
          validators: Validators.compose([
            Validators.pattern(this.validateSrv.nimaPattern),
            Validators.maxLength(10)
          ]),
        },
      ],
      suministraInfo: [{ value: null, disabled: false }],
    });
  }
  ngOnInit(): void {
    this.anioActual = new Date().getFullYear();
    for (let i = this.anioActual - 3; i <= this.anioActual + 1; i++) {
      this.anios.push({ id: i });
    }
    this.formGroup.get('anio')?.setValue(this.anioActual);
    this.anioSelected();
    this.mostrarImportar = this.anioActual === this.formGroup.get('anio')?.value;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.adheridoInfo) {
      this.anioSelected();
    }
  }
  getLerDescription(ler: any) {
    return ler?.tipoCodigo + ' - ' + ler?.descripcion;
  }

  getOperacionDescription(op: any) {
    return op?.descripcion;
  }

  getFormControl(selectForm: any): FormControl {
    switch (selectForm) {
      case 'codigoLer': {
        return this.formGroup.get('codigoLer') as FormControl;
      }
      default: {
        return this.formGroup.get('') as FormControl;
      }
    }
  }
  getObjectQuery(searchterm: string) {
    return {
      descripcion: searchterm
    };
  }

  public rightHolder(controlName: string) {
    let cl2 = '';
    if (
      (this.formGroup.controls[controlName]?.touched ||
        this.formGroup.controls[controlName]?.dirty) &&
      this.formGroup.controls[controlName]?.errors
    ) {
      cl2 = 'error-focus-input';
    } else {
      cl2 = 'success-focus-input';
    }
    return `${cl2}`;
  }

  selPaginatorHasError(controlName: string) {
    if (
      (this.formGroup.controls[controlName]?.touched ||
        this.formGroup.controls[controlName]?.dirty) &&
      this.formGroup.controls[controlName]?.errors
    ) {
      return true;
    } else {
      return false;
    }
  }

  controlHasError(controlName: string, errorName: string) {
    return (
      this.formGroup.controls[controlName].hasError(errorName) &&
      this.formGroup.controls[controlName].touched
    );
  }
  addPrevisionModal(): void {
    const dialogRef = this.dialog.open(WasteForecastAddDialogComponent, {
      width: '950px',
      maxWidth: '95%',
      maxHeight: '95vh',
      disableClose: true,
      data: {
        adheridoInfo: this.adheridoInfo,
        previsiones: this.grid,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.refrescarAdheridoEvent.emit(true);
        this.buscarPrevision();
      }
    });
  }

  action(event: any) {
    if (event.nameButton == 'delete') {
      this.confirmacionEliminarPrevision(event);
    } else if (event.nameButton == 'duplicate') {
      this.duplicatePrevision(event);
    } else if (event.nameButton == 'edit') {
      this.editPrevision(event);
    }
  }
  confirmacionEliminarPrevision(element?: any): void {
    Swal.fire({
      text: `¿Desea eliminar la previsión de residuos?`,
      icon: 'question',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Sí',
      denyButtonText: 'No',
      allowOutsideClick: false,
    }).then((result: any) => {
      if (result.isConfirmed) {
        // let body = this.adheridoInfo;
        // this.grid = this.grid.filter((x: any) => x.id !== element.id);
        // body.previsionResiduos = this.grid;
        this.adheridosPrevisionResiduosControllerService.deleteById3(element.id!).subscribe({
          next: (response: any) => {
            this.snackBarSrv.showSnackBar(
              'Se ha eliminado correctamente la previsión de residuos',
              'success'
            );
            this.refrescarAdheridoEvent.emit(true);
          },
          error: (err) => {},
        });
      }
    });
  }

  anioSelected(): void {
    this.buscarPrevision();
  }

  buscarPrevision(): void {
    if (
      !this.adheridoInfo?.previsionResiduos ||
      this.adheridoInfo?.previsionResiduos?.length === 0
    ) {
      this.grid = [];
      this.mostrarImportar = false;
      return;
    }

    const anio = this.formGroup.get('anio')?.value;
    const codigoLerId = this.formGroup.get('codigoLer')?.value?.id;
    const nima = this.formGroup.get('nima')?.value;
    const suministraInfo = this.formGroup.get('suministraInfo')?.value;

    let residuosFiltrados = this.adheridoInfo.previsionResiduos.filter(
      (x: any) =>
        (!anio || x.anioDatos == anio) &&
        (!codigoLerId || x.codigoLer?.id === codigoLerId) &&
        (!nima ||
          (x.nimaGestor ?? '')
            .toLowerCase()
            .includes(String(nima).toLowerCase())) &&
        (!suministraInfo || x.suministradorInformacion === suministraInfo)
    );

    this.mostrarImportar = !codigoLerId && !nima && !suministraInfo && this.anioActual === anio;

    if (residuosFiltrados?.length > 0) {
      let observables: any[] = [];

      residuosFiltrados.forEach((residuo: any) => {
        let observable = this.gestoresResiduosControllerService
          .findAll8(
            { nima: [residuo.nimaGestor] },
            {
              page: 0,
              size: 10,
            }
          )
          .pipe(
            map((resultado: any) => {
              residuo.existeNima = resultado.datos?.length != 0 ? true : false;
              return residuo;
            }),
            catchError((error: any) => {
              console.error(
                `Error comprobando Nima para residuo con id ${residuo.id}:`,
                error
              );
              residuo.existeNima = false;
              return of(residuo);
            })
          );
        observables.push(observable);
      });

      zip(...observables).subscribe((residuosActualizados: any[]) => {
        this.grid = this.canAccessAll(residuosActualizados);
      });
    } else {
      this.grid = [];
    }
  }

  showWarning(row: any) {
    return !row.existeNima;
  }

  canAccessDelete(): boolean {
    if (this.adheridoInfo?.estado?.id === 7) {
      return false;
    }

    return this.authService.can('adheridos-prevision', 'delete') || this.canViewResource('AD-ENV-GEST');
  }
  canAccessCreate(): boolean {
    if (this.adheridoInfo?.estado?.id === 7) {
      return false;
    }

    return this.authService.can('adheridos-prevision', 'add-prevision') || this.canViewResource('AD-ENV-GEST');
  }

  canAccessAll(list: any) {
    const resultDelete = this.canAccessDelete();
    const resultCreate = this.canAccessCreate();

    const listPermission = list.map((objeto: any) => {
      let descripcionMCodLer =
        objeto.codigoLer.tipoCodigo + ' ' + objeto.codigoLer.descripcion;
      return {
        ...objeto,
        descripcionMCodLer: descripcionMCodLer,
        canAccessDelete: resultDelete,
        canAccessEdit: resultDelete,
        canAccessDuplicate: resultCreate,
      };
    });

    return listPermission;
  }

  canViewResource(rol: string): boolean {
    return this.authService.hasCurrentUserRole(rol);
  }

  onInput(controlName: string, event: any) {
    const control = this.formGroup.get(controlName)
    const input = event.target as HTMLInputElement;
    control?.markAsTouched();
    control?.markAsDirty();
  }
  import() {
    if (
      this.adheridoInfo?.previsionResiduos &&
      this.adheridoInfo?.previsionResiduos?.length > 0
    ) {
        const dialogRef = this.dialog.open(UploadWasteForecastComponent, {
        width: '950px',
        maxWidth: '95%',
        maxHeight: '95vh',
        data: {
          previsionResiduos: this.adheridoInfo?.previsionResiduos,
          adheridoInfo: this.adheridoInfo,
          anio: this.formGroup.get('anio')?.value
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.anioSelected();
          this.refrescarAdheridoEvent.emit(true);
        }
      });
    }

    
  }
  duplicatePrevision(element?: any): void {
    const dialogRef = this.dialog.open(WasteForecastDuplicateDialogComponent, {
      width: '950px',
      maxWidth: '95%',
      maxHeight: '95vh',
      disableClose: true,
      data: {
        prevision: element,
        duplicar: true,
        adheridoInfo: this.adheridoInfo,
        previsiones: this.grid,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.refrescarAdheridoEvent.emit(true);
      }
    });
  }

  editPrevision(element?: any): void {
    const dialogRef = this.dialog.open(WasteForecastDuplicateDialogComponent, {
      width: '950px',
      maxWidth: '95%',
      maxHeight: '95vh',
      disableClose: true,
      data: {
        prevision: element,
        editar: true,
        adheridoInfo: this.adheridoInfo,
        previsiones: this.grid,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.refrescarAdheridoEvent.emit(true);
      }
    });
  }

  export() {
    if (this.exporting) return;
    this.exporting = true;
    this.spinnerSrv.loadingShow();
    this.adheridoEstadoService
      .exportPrevisionResiduosSddrCerrado(
        this.adheridoInfo?.id!,
        this.formGroup.controls['anio'].value,
        'response'
      )
      .subscribe({
        next: (res: any) => {
          try {
            const templateName = this.downloadService.getFileName(res.headers);
            this.downloadService.downloadBlob(res.body!, templateName ?? 'export.xlsx');
          } catch (e) {
            this.downloadService.exportModal();
          }
          this.spinnerSrv.loadingHide();
          this.exporting = false;
          
        },
        error: (error: any) => {
          this.spinnerSrv.loadingHide();
          this.exporting = false;
          this.snackBarSrv.showSnackBar('Ha ocurrido un error al descargar la exportación', 'error');
        },
      });
  }
}
